export enum OrderType {
  Order = 0,
  Quote = 1,
}